import React, { useState, useContext, useEffect } from "react";
import { UserContext } from '../context/User';
import { Spinner } from '../Spinner.js';
import { useNavigate } from 'react-router-dom'
import "./Login.css";

import { Button, TextField, Paper } from '@mui/material';

const Login = ({ fire }) => {
    const [loading, setLoading] = useState(false);
    const { user } = useContext(UserContext);

    const [emailSent, setEmailSent] = useState(false);
    const [newUser, setNewUser] = useState(false);
    const [updateInfo, setUpdateInfo] = useState(false);
    const [passReset, setPassReset] = useState(false);

    const [email, setEmail] = useState('');
    const [name, setName] = useState({ first: '', last: '' });
    const [photo, setPhoto] = useState('');
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const [update, setUpdate] = useState({
        updating: false,
        name: false,
        email: false,
        password: false
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (user && !user.isAnonymous) {
            setEmail(user.email);
            if (user.displayName) {
                setName({ first: user.displayName.split(' ')[0], last: user.displayName.split(' ')[1] });
            }
            setPhoto(user.photoURL);
            setUpdateInfo(user.emailVerified);
        }
    }, [user]);

    function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        if (passReset && email) {
            fire.resetPassword(email).then(val => {
                if (val) {
                    resetValues();
                    setPassReset(false);
                }
            });
        } else if (email && password) {
            fire.login({ email: email, password: password }).then(u => {
                resetValues();
                if(u) {
                    navigate('/home');
                }
            });
        }
    }

    function createUser(e) {
        e.preventDefault();
        setLoading(true);
        let fireUser = {
            email: email,
            password: password,
            name: name.first.trim() + ' ' + name.last.trim(),
            url: photo
        };
        fire.createUser(fireUser).then(res => {
            resetValues();
            if (res) {
                setNewUser(false);
            }
        });
    }

    function handleVerifyEmail(e) {
        e.preventDefault();
        setLoading(true);
        fire.verifyEmail().then(value => {
            resetValues();
            setEmailSent(value);
        });
    }

    function updateUser(field) {
        switch (field) {
            case 'name':
                if (update.name) {
                    setLoading(true);
                    fire.updateUserInfo(name.first + ' ' + name.last, photo).then(res => {
                        if (res) {
                            setLoading(false);
                        }
                    });
                }
                setUpdate({ ...update, updating: !update.updating, name: !update.name });
                break;
            case 'password':
                if (update.password) {
                    setLoading(true);
                    fire.changePassword(password, newPassword).then(res => {
                        if (res) {
                            setLoading(false);
                        }
                    });
                }
                setUpdate({ ...update, updating: !update.updating, password: !update.password });
                break;
            case 'email':
                if (update.email) {
                    setLoading(true);
                    fire.changeEmail(email, password).then(res => {
                        if (res) {
                            setLoading(false);
                        }
                    });
                }
                setUpdate({ ...update, updating: !update.updating, email: !update.email });
                break;
            default:
                break;
        }
    }

    function resetValues() {
        if (user && !user.isAnonymous) {
            setEmail(user.email);
            if (user.displayName) {
                setName({ first: user.displayName.split(' ')[0], last: user.displayName.split(' ')[1] });
            }
            setPhoto(user.photoURL);
            setUpdateInfo(true);
        } else {
            setEmail('');
            setName({ first: '', last: '' });
            setPhoto('');
        }
        setPassword('');
        setNewPassword('');
        setEmailSent(false);
        setLoading(false);
    }

    function cancelUpdate() {
        setUpdate({
            updating: false,
            name: false,
            email: false,
            password: false
        });
        resetValues();
    }

    if (!user || user.isAnonymous) {
        return (
            <div className="login">
                <h1>{passReset ? 'Reset Password' : newUser ? 'Register User' : 'Login'}</h1>
                <form onSubmit={newUser ? createUser : handleSubmit}>
                    {newUser &&
                        <div className="newUser">
                            <input
                                type="text"
                                placeholder="First Name"
                                autoComplete="off"
                                value={name.first}
                                onChange={(e) => setName({ ...name, first: e.target.value })}
                                style={{ marginTop: 0 }}
                                required
                            />
                            <input
                                type="text"
                                placeholder="Last Name"
                                autoComplete="off"
                                value={name.last}
                                onChange={(e) => setName({ ...name, last: e.target.value })}
                                required
                            />
                            <input
                                type="text"
                                placeholder="Email"
                                autoComplete="off"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Confirm Password"
                                autoComplete="current-password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                            {password !== newPassword &&
                                <span className="error">
                                    *The passwords must match
                                </span>
                            }
                        </div>
                    }
                    {!newUser && (
                        <>
                            <input
                                type="text"
                                placeholder="Email"
                                autoComplete="off"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ marginTop: 0 }}
                                required
                            />
                            {!passReset &&
                                <input
                                    type="password"
                                    placeholder="Password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            }
                        </>
                    )}
                    <button type="submit" value="Login" disabled={newUser && password !== newPassword}>
                        {newUser ? 'Register' : passReset ? 'Reset' : 'Login'}
                    </button>
                </form>
                <div className="buttonGroup">
                    {!passReset &&
                        <Button variant="text" color={newUser ? 'error' : 'success'} onClick={() => { setNewUser(!newUser); resetValues() }}>
                            {newUser ? 'Cancel' : 'Register'}
                        </Button>
                    }
                    {!newUser &&
                        <Button variant="text" color={passReset ? 'error' : 'warning'} onClick={() => { setPassReset(!passReset); resetValues() }}>
                            {passReset ? 'Cancel' : 'Forgot Password'}
                        </Button>
                    }
                </div>
                {loading &&
                    <Spinner isLoading={loading}></Spinner>
                }
            </div>
        );
    } else if (updateInfo) {
        return (
            <div>
                <Paper square={false} elevation={4}
                    sx={{
                        minWidth: 'max-content',
                        width: '30%',
                        padding: '2em',
                        position: "absolute",
                        top: '50%',
                        left: '50%',
                        transform: "translate(-50%, -50%)"
                    }}
                >
                    <div className="updateRow">
                        <TextField
                            label="First Name"
                            type="search"
                            variant="standard"
                            value={name.first}
                            onChange={(e) => setName({ ...name, first: e.target.value })}
                            disabled={!update.name}
                            required={update.name}
                        />
                        <TextField
                            label="Last Name"
                            type="search"
                            variant="standard"
                            value={name.last}
                            onChange={(e) => setName({ ...name, last: e.target.value })}
                            disabled={!update.name}
                            required={update.name}
                        />
                        <Button variant="outlined"
                            onClick={() => updateUser('name')}
                            disabled={(update.updating && !update.name) || !(name.first && name.last)}
                        >
                            {update.name ? 'Update' : 'Edit'}
                        </Button>
                        {update.name &&
                            <Button variant="outlined" onClick={cancelUpdate}>
                                Cancel
                            </Button>
                        }
                    </div>
                    <div className="updateRow">
                        <TextField
                            label="New Email"
                            type="search"
                            variant="standard"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={!update.email}
                            required={update.email}
                        />
                        {update.email &&
                            <div className="textRow" style={{ marginRight: '1em' }}>
                                <input
                                    type="password"
                                    placeholder="Enter current password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        }
                        <Button variant="outlined" onClick={() => updateUser('email')}
                            disabled={(update.updating && !update.email) || !email}
                        >
                            {update.email ? 'Update' : 'Edit'}
                        </Button>
                        {update.email &&
                            <Button variant="outlined" onClick={cancelUpdate}>
                                Cancel
                            </Button>
                        }
                    </div>
                    <div className="updateRow">
                        {update.password &&
                            <div className="textRow" style={{ marginRight: '1em' }}>
                                <input
                                    type="password"
                                    placeholder="Enter current password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <input
                                    type="password"
                                    placeholder="Enter new password"
                                    autoComplete="current-password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </div>
                        }
                        <Button variant="outlined"
                            onClick={() => updateUser('password')}
                            disabled={(update.updating && !update.password) || (!password || !newPassword)}
                        >
                            {update.password ? 'Update' : 'Edit'}
                        </Button>
                        {update.password &&
                            <Button variant="outlined" onClick={cancelUpdate}>
                                Cancel
                            </Button>
                        }
                    </div>
                </Paper>
            </div>
        );
    } else {
        return (
            <EmailVerification verify={handleVerifyEmail} sent={emailSent} />
        );
    }
};

function EmailVerification({ verify, sent }) {
    return (
        <div className="login">
            <div>
                {sent
                    ?
                    'Check your email for a verification link to verify your email address then log back in.'
                    :
                    '*Your email has not been verified. Please verify your email and sign back in.'
                }
            </div>
            <Button variant="outlined" onClick={verify}>
                {sent ? 'Re-send' : 'Send'} Email Verification
            </Button>
        </div>
    );
}

export default Login